import LabFeatures from '@polleverywhere/core/lib/models/lab_features'
import { defaults } from 'underscore'

export default function saveFeature (user, featureName, enabled) {
  const labs = new LabFeatures({ user })
  const data = { [featureName]: enabled }

  return labs.save(data).then(() => {
    user.set('features', defaults(data, user.get('features')))
  })
}
